/**
 * BOGO 1+1 — Pair 1 from native product form, Pair 2 from metafield UI.
 * Mobile Pair 2 uses drawer triggers like Pair 1.
 * Wrapped so errors never break theme gallery/accordion JS.
 */
(function () {
  try {
    var SELECTOR = "[data-bogo-pair-options]";

    function normalize(str) {
      return (str || "").toString().trim().toLowerCase();
    }

    function parseVariants(root) {
      var el = root.querySelector("[data-bogo-variants]");
      if (!el) return [];
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return [];
      }
    }

    function getPair2Selections(root) {
      var sizeInput = root.querySelector(
        'input[data-bogo-pair="2"][data-option-role="size"]:checked'
      );
      var colorInput = root.querySelector(
        'input[data-bogo-pair="2"][data-option-role="color"]:checked'
      );
      return {
        size: sizeInput ? sizeInput.value : null,
        color: colorInput ? colorInput.value : null,
        sizeIndex: root.getAttribute("data-size-option-index"),
        colorIndex: root.getAttribute("data-color-option-index"),
      };
    }

    function findVariant(variants, selectedByIndex) {
      return variants.find(function (variant) {
        for (var i = 0; i < 3; i++) {
          if (selectedByIndex[i] == null || selectedByIndex[i] === "") continue;
          var key = "option" + (i + 1);
          if (normalize(variant[key]) !== normalize(selectedByIndex[i])) {
            return false;
          }
        }
        return true;
      });
    }

    function getPair1Root() {
      return document.querySelector("[data-bogo-pair-1]");
    }

    function getPair1Desktop(pair1Root) {
      var root = pair1Root || getPair1Root();
      if (!root) return null;
      return root.querySelector(".tt-swatches-container.desktop");
    }

    function getPair1SelectedByIndex(pair1Root) {
      var selected = [];
      var root = pair1Root || getPair1Root();
      var desktop = getPair1Desktop(root);

      if (desktop) {
        desktop.querySelectorAll(".tt-option-wrapper").forEach(function (wrapper) {
          var anyInput = wrapper.querySelector('input[type="radio"]');
          var idx = 0;
          if (anyInput) {
            var optionIndex = anyInput.getAttribute("optionIndex");
            if (optionIndex) {
              idx = parseInt(String(optionIndex).replace("option", ""), 10) - 1;
              if (Number.isNaN(idx) || idx < 0) idx = 0;
            }
          }

          var labelEl = wrapper.querySelector(".current_option_name");
          var fromLabel = labelEl ? labelEl.textContent.trim() : "";
          var checked = wrapper.querySelector('input[type="radio"]:checked');
          var fromRadio = checked ? checked.value : "";
          var value = fromLabel || fromRadio;
          if (value) selected[idx] = value;
        });
      }

      if (root) {
        root.querySelectorAll(".mobile-variant-trigger").forEach(function (trigger) {
          var optionIndex = trigger.getAttribute("data-option-index");
          var idx = optionIndex ? parseInt(optionIndex, 10) - 1 : -1;
          if (idx < 0 || selected[idx]) return;
          var valueEl = trigger.querySelector(".mobile-variant-trigger-value");
          var value = valueEl
            ? valueEl.getAttribute("data-option-value") || valueEl.textContent.trim()
            : "";
          if (value) selected[idx] = value;
        });
      }

      return selected;
    }

    function getPair1VariantFromUi(variants, pair1Root) {
      return findVariant(variants, getPair1SelectedByIndex(pair1Root)) || null;
    }

    function getPair1VariantFromForm(variants) {
      var form = document.getElementById("product-form-atc");
      if (!form) return null;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return null;
      var id = String(idInput.value);
      return (
        variants.find(function (v) {
          return String(v.id) === id;
        }) || null
      );
    }

    function syncPair1VisualState(wrapper) {
      if (!wrapper) return;
      wrapper.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        var label =
          radio.nextElementSibling && radio.nextElementSibling.tagName === "LABEL"
            ? radio.nextElementSibling
            : wrapper.querySelector('label[for="' + radio.id + '"]');
        if (radio.checked) {
          radio.setAttribute("checked", "checked");
          if (label) {
            label.classList.add("variant-option-checked");
            if (label.classList.contains("swatch-color-option")) {
              label.classList.add("swatch-checked");
            }
          }
        } else {
          radio.removeAttribute("checked");
          if (label) {
            label.classList.remove("swatch-checked", "variant-option-checked");
          }
        }
      });
    }

    function syncPair1VariantToForm(input) {
      var variants = [];
      try {
        if (window.productJson) variants = JSON.parse(window.productJson);
      } catch (e) {
        variants = [];
      }
      if (!variants.length) return;

      var pair1Variant = getPair1VariantFromUi(variants) || getPair1VariantFromForm(variants);
      if (!pair1Variant || !pair1Variant.id) return;

      var form = document.getElementById("product-form-atc");
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      if (idInput) idInput.value = String(pair1Variant.id);
      if (input) input.setAttribute("var_id", String(pair1Variant.id));

      if (typeof window.R2BApplyVariantChange === "function") {
        window.R2BApplyVariantChange(String(pair1Variant.id));
      }
    }

    function selectPair1Input(input) {
      if (!input || input.disabled) return;
      var wrapper = input.closest(".tt-option-wrapper");
      var name = input.getAttribute("name");
      var scope = wrapper || getPair1Desktop();
      if (scope && name) {
        scope
          .querySelectorAll('input[name="' + String(name).replace(/"/g, '\\"') + '"]')
          .forEach(function (radio) {
            if (radio === input) {
              radio.checked = true;
              radio.setAttribute("checked", "checked");
            } else {
              radio.checked = false;
              radio.removeAttribute("checked");
            }
          });
      } else {
        input.checked = true;
        input.setAttribute("checked", "checked");
      }

      if (wrapper) {
        var currentEl = wrapper.querySelector(".current_option_name");
        if (currentEl) currentEl.textContent = input.value;
        syncPair1VisualState(wrapper);
      }

      input.dispatchEvent(new Event("change", { bubbles: true }));
      syncPair1VariantToForm(input);

      window.setTimeout(function () {
        input.checked = true;
        input.setAttribute("checked", "checked");
        if (wrapper) {
          var currentEl = wrapper.querySelector(".current_option_name");
          if (currentEl) currentEl.textContent = input.value;
          syncPair1VisualState(wrapper);
        }
      }, 0);
    }

    function initPair1Selection() {
      var pair1Root = getPair1Root();
      if (!pair1Root || pair1Root.dataset.bogoPair1Init === "true") return;
      pair1Root.dataset.bogoPair1Init = "true";

      var desktop = getPair1Desktop(pair1Root);
      if (desktop) {
        desktop.querySelectorAll(".tt-option-wrapper").forEach(function (wrapper) {
          var labelEl = wrapper.querySelector(".current_option_name");
          var wanted = labelEl ? labelEl.textContent.trim() : "";
          var checked = wrapper.querySelector('input[type="radio"]:checked');
          if (wanted && (!checked || normalize(checked.value) !== normalize(wanted))) {
            wrapper.querySelectorAll('input[type="radio"]').forEach(function (radio) {
              if (normalize(radio.value) === normalize(wanted)) {
                radio.checked = true;
                radio.setAttribute("checked", "checked");
              } else {
                radio.checked = false;
                radio.removeAttribute("checked");
              }
            });
          }
          syncPair1VisualState(wrapper);
        });
      }

      pair1Root.addEventListener(
        "click",
        function (event) {
          var label = event.target.closest("label.swatch-input__label");
          if (!label || !pair1Root.contains(label)) return;

          var input = null;
          var inputId = label.getAttribute("for");
          if (inputId) input = document.getElementById(inputId);
          if (!input || !pair1Root.contains(input)) {
            input = label.previousElementSibling;
          }
          if (!input || input.type !== "radio" || input.disabled) return;

          event.preventDefault();
          event.stopPropagation();
          selectPair1Input(input);
        },
        true
      );
    }

    function collectPair2Options(root) {
      var selected = [];
      var pair2 = getPair2Selections(root);
      var sizeIdx = parseInt(pair2.sizeIndex, 10);
      var colorIdx = parseInt(pair2.colorIndex, 10);

      if (!Number.isNaN(sizeIdx) && pair2.size) selected[sizeIdx] = pair2.size;
      if (!Number.isNaN(colorIdx) && pair2.color) selected[colorIdx] = pair2.color;

      if (selected.length === 0 || (selected[0] == null && selected[1] == null)) {
        if (pair2.size) selected[0] = pair2.size;
        if (pair2.color) selected[1] = pair2.color;
      }
      return selected;
    }

    function setError(root, message) {
      var errorEl = root.querySelector("[data-bogo-error]");
      if (!errorEl) return;
      if (message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      } else {
        errorEl.textContent = "";
        errorEl.hidden = true;
      }
    }

    function resolvePairs(root) {
      var variants = parseVariants(root);
      var pair1Variant =
        getPair1VariantFromUi(variants) ||
        getPair1VariantFromForm(variants) ||
        variants.find(function (v) {
          return v.available;
        }) ||
        variants[0];
      var pair2Variant = findVariant(variants, collectPair2Options(root));
      return { pair1Variant: pair1Variant, pair2Variant: pair2Variant };
    }

    function getCartItems(root) {
      root = root || document.querySelector(SELECTOR);
      if (!root) return null;

      var resolved = resolvePairs(root);
      var messages =
        window.themeStrings && window.themeStrings.bogo
          ? window.themeStrings.bogo
          : {};

      if (!resolved.pair1Variant || !resolved.pair1Variant.id) {
        setError(root, messages.pair1_unavailable || "Pair 1 unavailable.");
        return null;
      }
      if (!resolved.pair2Variant || !resolved.pair2Variant.id) {
        setError(root, messages.pair2_unavailable || "Pair 2 unavailable.");
        return null;
      }
      if (!resolved.pair1Variant.available) {
        setError(root, messages.pair1_unavailable || "Pair 1 sold out.");
        return null;
      }
      if (!resolved.pair2Variant.available) {
        setError(root, messages.pair2_unavailable || "Pair 2 sold out.");
        return null;
      }

      setError(root, null);
      var groupId =
        "bogo-" +
        Date.now().toString(36) +
        "-" +
        Math.random().toString(36).slice(2, 8);
      return {
        items: [
          {
            id: resolved.pair2Variant.id,
            quantity: 1,
            properties: {
              _bogo_role: "free",
              _bogo_pair: "2",
              _bogo_bundle: "1-plus-1",
              _bogo_group: groupId,
            },
          },
          {
            id: resolved.pair1Variant.id,
            quantity: 1,
            properties: {
              _bogo_role: "paid",
              _bogo_pair: "1",
              _bogo_bundle: "1-plus-1",
              _bogo_group: groupId,
            },
          },
        ],
      };
    }

    function updateCurrentLabels(input) {
      if (!input) return;
      var optionNode = input.closest("[data-bogo-option]");
      if (!optionNode) return;
      var currentEl = optionNode.querySelector("[data-bogo-current-value]");
      if (currentEl) currentEl.textContent = input.value;
    }

    function syncMobileTriggers(root, role, value, swatchColor) {
      var trigger = root.querySelector(
        '[data-bogo-mobile-trigger][data-option-role="' + role + '"]'
      );
      if (!trigger) return;
      var valueEl = trigger.querySelector("[data-bogo-trigger-value]");
      if (valueEl) valueEl.textContent = value || "";

      if (role === "color") {
        var swatch = trigger.querySelector("[data-bogo-trigger-swatch]");
        if (swatch && swatchColor) {
          swatch.style.backgroundColor = swatchColor;
          swatch.setAttribute("data-color", swatchColor);
        }
      }
    }

    function syncDrawerSelectedState(root, role, value) {
      root.querySelectorAll(
        '[data-bogo-drawer-option][data-option-role="' + role + '"]'
      ).forEach(function (btn) {
        if (btn.getAttribute("data-option-value") === value) {
          btn.classList.add("is-selected");
        } else {
          btn.classList.remove("is-selected");
        }
      });
    }

    function selectPair2Input(input) {
      if (!input || input.disabled) return;
      var name = input.getAttribute("name");
      var root = input.closest(SELECTOR);
      if (root && name) {
        root
          .querySelectorAll('input[name="' + name.replace(/"/g, '\\"') + '"]')
          .forEach(function (radio) {
            if (radio === input) {
              radio.checked = true;
              radio.setAttribute("checked", "checked");
            } else {
              radio.checked = false;
              radio.removeAttribute("checked");
            }
          });
      } else {
        input.checked = true;
        input.setAttribute("checked", "checked");
      }
      updateCurrentLabels(input);
      if (root) {
        var role = input.getAttribute("data-option-role");
        syncMobileTriggers(
          root,
          role,
          input.value,
          input.getAttribute("data-swatch-color")
        );
        syncDrawerSelectedState(root, role, input.value);
        setError(root, null);
      }
    }

    function selectPair2ByRoleValue(root, role, value) {
      var input = root.querySelector(
        'input[data-bogo-pair="2"][data-option-role="' +
          role +
          '"][value="' +
          String(value).replace(/"/g, '\\"') +
          '"]'
      );
      if (!input) {
        root
          .querySelectorAll(
            'input[data-bogo-pair="2"][data-option-role="' + role + '"]'
          )
          .forEach(function (radio) {
            if (normalize(radio.value) === normalize(value)) input = radio;
          });
      }
      if (input) selectPair2Input(input);
    }

    function closeBogoDrawer(root) {
      var drawer = root.querySelector("[data-bogo-drawer]");
      var overlay = root.querySelector("[data-bogo-drawer-overlay]");
      if (drawer) {
        drawer.classList.remove("is-active");
        drawer.setAttribute("hidden", "");
      }
      if (overlay) {
        overlay.classList.remove("is-active");
        overlay.setAttribute("hidden", "");
      }
      document.documentElement.classList.remove("bogo-drawer-active");
      root
        .querySelectorAll("[data-bogo-drawer-panel]")
        .forEach(function (panel) {
          panel.setAttribute("hidden", "");
        });
    }

    function openBogoDrawer(root, role) {
      var drawer = root.querySelector("[data-bogo-drawer]");
      var overlay = root.querySelector("[data-bogo-drawer-overlay]");
      var panel = root.querySelector(
        '[data-bogo-drawer-panel="' + role + '"]'
      );
      var trigger = root.querySelector(
        '[data-bogo-mobile-trigger][data-option-role="' + role + '"]'
      );
      if (!drawer || !panel || !trigger) return;

      root
        .querySelectorAll("[data-bogo-drawer-panel]")
        .forEach(function (p) {
          p.setAttribute("hidden", "");
        });
      panel.removeAttribute("hidden");

      var label =
        (trigger.querySelector(".mobile-variant-trigger-label") &&
          trigger
            .querySelector(".mobile-variant-trigger-label")
            .textContent.replace(":", "")
            .trim()) ||
        role;
      var value =
        (trigger.querySelector("[data-bogo-trigger-value]") &&
          trigger.querySelector("[data-bogo-trigger-value]").textContent.trim()) ||
        "";
      var swatchColor = "";
      var triggerSwatch = trigger.querySelector("[data-bogo-trigger-swatch]");
      if (triggerSwatch) {
        swatchColor =
          triggerSwatch.getAttribute("data-color") ||
          triggerSwatch.style.backgroundColor ||
          "";
      }

      var titleEl = drawer.querySelector("[data-bogo-drawer-title]");
      var selectedEl = drawer.querySelector("[data-bogo-drawer-selected]");
      if (titleEl) titleEl.textContent = label;
      if (selectedEl) {
        selectedEl.textContent = value;
        var existing = selectedEl.querySelector(".bogo-drawer__title-swatch");
        if (existing) existing.remove();
        if (role === "color" && swatchColor) {
          var titleSwatch = document.createElement("span");
          titleSwatch.className = "bogo-drawer__title-swatch";
          titleSwatch.style.backgroundColor = swatchColor;
          selectedEl.appendChild(titleSwatch);
        }
      }

      syncDrawerSelectedState(root, role, value);

      drawer.removeAttribute("hidden");
      if (overlay) {
        overlay.removeAttribute("hidden");
        overlay.classList.add("is-active");
      }
      requestAnimationFrame(function () {
        drawer.classList.add("is-active");
      });
      document.documentElement.classList.add("bogo-drawer-active");
    }

    function init(root) {
      if (!root || root.dataset.bogoInit === "true") return;
      root.dataset.bogoInit = "true";

      root.addEventListener(
        "click",
        function (event) {
          var trigger = event.target.closest("[data-bogo-mobile-trigger]");
          if (trigger && root.contains(trigger)) {
            event.preventDefault();
            event.stopPropagation();
            openBogoDrawer(root, trigger.getAttribute("data-option-role"));
            return;
          }

          if (event.target.closest("[data-bogo-drawer-close]")) {
            event.preventDefault();
            closeBogoDrawer(root);
            return;
          }

          var overlay = event.target.closest("[data-bogo-drawer-overlay]");
          if (overlay && root.contains(overlay)) {
            closeBogoDrawer(root);
            return;
          }

          var drawerOption = event.target.closest("[data-bogo-drawer-option]");
          if (drawerOption && root.contains(drawerOption)) {
            event.preventDefault();
            event.stopPropagation();
            var role = drawerOption.getAttribute("data-option-role");
            var value = drawerOption.getAttribute("data-option-value");
            selectPair2ByRoleValue(root, role, value);
            closeBogoDrawer(root);
            return;
          }

          var label = event.target.closest("label.bogo-pair__swatch-label");
          if (!label || !root.contains(label)) return;

          var inputId = label.getAttribute("for");
          var input = inputId ? document.getElementById(inputId) : null;
          if (!input || !root.contains(input)) {
            input = label.previousElementSibling;
          }
          if (
            !input ||
            input.type !== "radio" ||
            !input.hasAttribute("data-bogo-pair")
          ) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          selectPair2Input(input);
        },
        true
      );

      root.addEventListener("change", function (event) {
        if (!event.target.matches("input[data-bogo-pair]")) return;
        event.stopPropagation();
        updateCurrentLabels(event.target);
        syncMobileTriggers(
          root,
          event.target.getAttribute("data-option-role"),
          event.target.value,
          event.target.getAttribute("data-swatch-color")
        );
        setError(root, null);
      });

      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        if (!root.querySelector("[data-bogo-drawer].is-active")) return;
        closeBogoDrawer(root);
      });
    }

    function initAll() {
      initPair1Selection();
      document.querySelectorAll(SELECTOR).forEach(init);
    }

    window.R2BBogo = { getCartItems: getCartItems, initAll: initAll };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initAll);
    } else {
      initAll();
    }
    document.addEventListener("shopify:section:load", initAll);
  } catch (err) {
    console.warn("BOGO init skipped:", err);
  }
})();
